// Buy Box › Agents: manage saved Buy Box versions and up to 3 daily agents.

import AppLayout from "@/components/app-layout";
import { ViewOnlyBanner, usePermissions } from "@/hooks/use-permissions";
import { Bot } from "lucide-react";
import { GuideButton } from "@/components/guide-button";
import { ExplainerVideoButton } from "@/components/explainer-video-button";
import { GuideNudgeBanner } from "@/components/guide-nudge-banner";
import { usePageTitle } from "@/hooks/use-page-title";
import { BuyBoxSubnav } from "@/components/buy-box/buy-box-subnav";
import { BuyBoxAgentsCard } from "@/components/buy-box/buy-box-agents-card";
import { BuyBoxVersionsCard } from "@/components/buy-box/buy-box-versions-card";

export default function AppBuyBoxAgents() {
  usePageTitle("Buy Box Agents");
  const { canEdit } = usePermissions();
  const readOnly = !canEdit("underwriting");
  return (
    <AppLayout>
      <div className="p-6 max-w-3xl">
        <ViewOnlyBanner area="underwriting" />
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Bot className="h-6 w-6 text-blue-600" />
            <h1 className="text-2xl font-bold text-gray-900" data-tour="buy-box-agents-heading">Buy Box Agents</h1>
          </div>
          <div className="flex items-center gap-2">
            <ExplainerVideoButton pageKey="buy-box-agents" />
            <GuideButton pageKey="buy-box-agents" />
          </div>
        </div>
        <BuyBoxSubnav />
        <GuideNudgeBanner pageKey="buy-box-agents" />
        <BuyBoxAgentsCard readOnly={readOnly} />
        <BuyBoxVersionsCard readOnly={readOnly} />
      </div>
    </AppLayout>
  );
}
